module.exports = "/build/web/svg/social/default/twitter.8046486be6f5ca7fd387a191df989da2.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/twitter.svg
// module id = 187
// module chunks = 24